export const US_ZIP_REGEX = /^\d{5}$/

/** Shown under the field after blur / failed submit (not while focused). */
export const ZIP_CODE_ERROR_MESSAGE = 'Enter a valid ZIP code'

export function digitsOnlyZip(input) {
  return String(input ?? '').replace(/\D/g, '')
}

/** Formats as user types: up to 5 digits (US ZIP). */
export function formatZipAsTyped(raw) {
  return digitsOnlyZip(raw).slice(0, 5)
}

/** Keeps only digits, max length 5. */
export function sanitizeZipInput(raw) {
  return formatZipAsTyped(raw)
}

export function isValidUsZip(value) {
  const s = String(value ?? '').trim()
  if (!s) return false
  return US_ZIP_REGEX.test(s)
}

/** Donor profile ZIP from `/auth/me` (nested address or top-level). */
export function getDonorProfileZipCode(donor) {
  const raw = donor?.zip_code ?? donor?.address?.zip_code ?? ''
  return digitsOnlyZip(raw).slice(0, 5)
}
